<template>
  <div
    v-ripple
    @click="scrollTo"
    class="category-card mx-4 d-flex flex-column align-center"
  >
    <img :src="img" :alt="title" />
    <div class="primary--text text-center font-weight-bold">{{ title }}</div>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
  methods: {
    scrollTo() {
      const id = this.formatToURL(this.title);

      const goTo = document.getElementById(id).getBoundingClientRect().top;
      window.scrollBy({ top: goTo, behavior: "smooth" });
    },
    formatToURL,
  },
};
</script>

<style>
.category-card {
  cursor: pointer;
}

.category-card img {
  aspect-ratio: 1;
  width: 100%;
  max-width: 140px;
}
</style>
